export const allCountryCodes = ["AD", "AE", "AF", "AG", "AI", "AL", "AM", "AO", "AR", "AS", "AT", "AU", "AW", "AX", "AZ", "BA", "BB", "BD", "BE", "BF", "BG", "BH", "BI", "BJ", "BL", "BM", "BN", "BO", "BQ", "BR", "BS", "BT", "BV", "BW", "BY", "BZ", "CA", "CC", "CD", "CF", "CG", "CH", "CI", "CK", "CL", "CM", "CN", "CO", "CR", "CU", "CV", "CW", "CX", "CY", "CZ", "DE", "DJ", "DK", "DM", "DO", "DZ", "EC", "EE", "EG", "EH", "ER", "ES", "ET", "FI", "FJ", "FK", "FM", "FO", "FR", "GA", "GB", "GD", "GE", "GF", "GG", "GH", "GI", "GL", "GM", "GN", "GP", "GQ", "GR", "GT", "GU", "GW", "GY", "HK", "HM", "HN", "HR", "HT", "HU", "ID", "IE", "IL", "IM", "IN", "IO", "IQ", "IR", "IS", "IT", "JE", "JM", "JO", "JP", "KE", "KG", "KH", "KI", "KM", "KN", "KP", "KR", "KW", "KY", "KZ", "LA", "LB", "LC", "LI", "LK", "LR", "LS", "LT", "LU", "LV", "LY", "MA", "MC", "MD", "ME", "MF", "MG", "MH", "MK", "ML", "MM", "MN", "MO", "MP", "MQ", "MR", "MS", "MT", "MU", "MV", "MW", "MX", "MY", "MZ", "NA", "NC", "NE", "NF", "NG", "NI", "NL", "NO", "NP", "NR", "NU", "NZ", "OM", "PA", "PE", "PF", "PG", "PH", "PK", "PL", "PM", "PN", "PR", "PT", "PW", "PY", "QA", "RE", "RO", "RS", "RU", "RW", "SA", "SB", "SC", "SD", "SE", "SG", "SH", "SI", "SJ", "SK", "SL", "SM", "SN", "SO", "SR", "SS", "ST", "SV", "SX", "SY", "SZ", "TC", "TD", "TF", "TG", "TH", "TJ", "TK", "TL", "TM", "TN", "TO", "TR", "TT", "TV", "TW", "TZ", "UA", "UG", "UM", "US", "UY", "UZ", "VA", "VC", "VE", "VG", "VI", "VN", "VU", "WF", "WS", "YE", "YT", "ZA", "ZM", "ZW"] as const;
export type AllCountryCodes = (typeof allCountryCodes)[number];

export const matchAndClubCountryCodes = ["fr", "de", "it", "be", "ch", "lu", "re"] as const;
export type MatchAndClubCountryCode = (typeof matchAndClubCountryCodes)[number];

export const clubCountryCodes = ["fr", "de", "it", "be", "ch", "lu", "re", "se", "at", "dk"] as const;
export type ClubCountryCodes = (typeof clubCountryCodes)[number];

export const countryFRNamesList = allCountryCodes.map((code) => {
  return {
    code,
    name: formatCountryNameFromCountryCode(code, "fr"),
  };
});

export const countryENNamesList = allCountryCodes.map((code) => {
  return {
    code,
    name: formatCountryNameFromCountryCode(code, "en"),
  };
});
export const clubCountryFRNamesList = clubCountryCodes.map((code) => {
  return {
    code,
    name: formatCountryNameFromCountryCode(code, "fr"),
  };
});

export const clubCountryENNamesList = clubCountryCodes.map((code) => {
  return {
    code,
    name: formatCountryNameFromCountryCode(code, "en"),
  };
});

export function formatCountryNameFromCountryCode(code: AllCountryCodes | ClubCountryCodes, userLocale: Intl.LocalesArgument) {
  if (!allCountryCodes.includes(code.toUpperCase() as AllCountryCodes) && !clubCountryCodes.includes(code.toUpperCase() as ClubCountryCodes)) {
    throw new Error(`Invalid country code: ${code}`);
  }

  return new Intl.DisplayNames(userLocale, { type: "region" })
    .of(code.toUpperCase()) ?? "Unknown country";
}
